import { jsx } from 'react/jsx-runtime';
import { motion } from 'framer-motion';

const BusyIndicator = () => {
  return jsx(motion.div, {
    className: "llm__busyIndicator",
    initial: {
      opacity: 0,
      y: 10
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 1
    },
    children: jsx("span", {})
  });
};

export { BusyIndicator };
//# sourceMappingURL=busyindicator.js.map
